export const VIDEO_MODAL_PER_PAGE = 10;
